"use strict";
'use client';
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var div_1 = tslib_1.__importDefault(require("../div"));
var popper_style_1 = require("./popper.style");
var Popper = function (_a) {
    var showPopper = _a.showPopper, _b = _a.position, position = _b === void 0 ? 'bottom' : _b, _c = _a.closeOnScroll, closeOnScroll = _c === void 0 ? false : _c, _d = _a.closeOnClickOutside, closeOnClickOutside = _d === void 0 ? true : _d, className = _a.className, children = _a.children, handlePopper = _a.handlePopper;
    var popperRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (popperRef.current && popperRef.current.children[1]) {
            popperRef.current.children[1].className = "".concat(popperRef.current.children[1].className, " absolute h-auto ").concat(popper_style_1.POPPER_CONTENT_POSITION[position]);
        }
    }, []);
    // toggle when click popper handler and close when click popper content
    (0, react_1.useEffect)(function () {
        function clicked(event) {
            var _a;
            var targets = event.target;
            if (popperRef.current && ((_a = popperRef.current.childNodes[0]) === null || _a === void 0 ? void 0 : _a.contains(targets))) {
                handlePopper(showPopper);
            }
        }
        document.addEventListener("click", clicked);
        return function () {
            document.removeEventListener("click", clicked);
        };
    }, [showPopper]);
    // show or hide Popper Content based on showPopper state
    (0, react_1.useEffect)(function () {
        var _a;
        var childNode = (_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.childNodes[1];
        if (childNode instanceof HTMLElement) {
            childNode.style.display = !showPopper ? 'none' : 'block';
        }
    }, [showPopper]);
    // close popper when user on scrolling page
    (0, react_1.useEffect)(function () {
        var handleClosePopper = function (event) {
            var _a;
            var targets = event.target;
            if (showPopper && closeOnScroll && popperRef.current && !((_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.contains(targets))) {
                handlePopper(showPopper);
            }
        };
        document.addEventListener("scroll", handleClosePopper);
        return function () {
            document.removeEventListener("scroll", handleClosePopper);
        };
    }, [showPopper, closeOnScroll]);
    // close popper when user click outside
    (0, react_1.useEffect)(function () {
        var handleClosePopper = function (event) {
            var _a;
            var targets = event.target;
            if (showPopper && closeOnClickOutside && popperRef.current && !((_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.contains(targets))) {
                handlePopper(showPopper);
            }
        };
        document.addEventListener("mousedown", handleClosePopper);
        return function () {
            document.removeEventListener("mousedown", handleClosePopper);
        };
    }, [showPopper, closeOnClickOutside]);
    return (react_1["default"].createElement(div_1["default"], { ref: popperRef, className: (0, class_names_1["default"])('relative h-auto w-auto z-10', popper_style_1.POPPER_POSITION[position], className) }, children));
};
exports["default"] = Popper;
//# sourceMappingURL=popper.js.map